import {createLazyFileRoute} from '@tanstack/react-router'

import FoodPayment from '@/views/FoodGrubhub/FoodGrubhubPayment/FoodGrubhubPayment'

export const Route = createLazyFileRoute('/_food-grubhub/food/payment/')({
  component: FoodPayment,
})
